module.exports = __webpack_public_path__ + "static/media/lock-pale.27864688.svg";